var ko = require('knockout');
var $ = require('jquery');

ko.components.register('media-tile', {
  viewModel: require('./media-tile'),
  template: require('./media-tile.template')
});

$('[data-media-tile]').each(function() {
  ko.applyBindings({}, this);
});
